import t from 'tcomb';

const Pin = t.subtype(t.Str, function(x) {

  return x.length === 4; // && t.is_digits(x);
});

module.exports = Pin;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Pin.js
 **/